import { render, staticRenderFns } from "./TopFundedCategories.vue?vue&type=template&id=25d8df5a&scoped=true&"
import script from "./TopFundedCategories.vue?vue&type=script&lang=js&"
export * from "./TopFundedCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d8df5a",
  null
  
)

export default component.exports